import axios from "axios";
import qs from "qs";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

import AuthToken from "./auth-token.service";
import { store } from "../store";
import { logOut } from "../actions/auth.actions";
import config from "../config";
import PusherService from "./pusher.service";

const axiosRunner = axios.create({
  baseURL: config.API_URL,
  timeout: 72000
});

const addTokenToRequest = config => {
  const authToken = AuthToken.get();
  if (authToken) config.headers["Authorization"] = authToken;
  return config;
};

const handleRequestError = error => Promise.reject(error);
const handleResponseError = error => {
  if (error.response.status === 401) {
    store.dispatch(logOut());
  }
  return Promise.reject(error);
};

const handlePusherSubscription = data => {
  const subscribe = get(data, "data.meta.subscribe", null);
  if (!isEmpty(subscribe)) {
    const { channel, event } = subscribe;
    PusherService.handleCommonEvent(event, channel);
  }
  return data;
};

const serializeQueryParams = config => {
  config.paramsSerializer = params => {
    return qs.stringify(params, {
      arrayFormat: "brackets",
      encode: false
    });
  };
  return config;
};

axiosRunner.interceptors.request.use(config => serializeQueryParams(addTokenToRequest(config)), handleRequestError);

axiosRunner.interceptors.response.use(response => handlePusherSubscription(response), handleResponseError);

class Api {
  static get(url, options) {
    return axiosRunner.get(url, options);
  }

  static post(url, data) {
    return axiosRunner.post(url, data, {
      headers: { "Content-Type": "application/vnd.api+json" }
    });
  }

  static put(url, data) {
    return axiosRunner.put(url, data, {
      headers: { "Content-Type": "application/vnd.api+json" }
    });
  }

  static patch(url, data) {
    return axiosRunner.patch(url, data, {
      headers: { "Content-Type": "application/vnd.api+json" }
    });
  }

  static delete(url) {
    return axiosRunner.delete(url);
  }
}
export default Object.freeze(Api);
